import {NgModule}                              from '@angular/core';
import {CommonModule}                          from '@angular/common';
import {ApNutrientManagementRoutes}            from './ap-nutrient-management.routes';
import {
  BodyModule,
  ExcelModule,
  GridModule,
  GroupModule,
  HeaderModule,
  PagerModule,
  PDFModule,
  SharedModule
}                                              from '@progress/kendo-angular-grid';
import {ApCoreModule}                          from '../ap-core/ap-core.module';
import {ApIconModule}                          from '../icons/ap-icon.module';
import {ButtonModule}                          from '@progress/kendo-angular-buttons';
import {ApTranslationModule}                   from '../translation/ap-translation.module';
import {ApSoilSamplePlanningOverviewComponent} from './components/ap-soilsampleplanning-overview.component';
import {ApNutrientDistributionComponent}       from './components/ap-nutrient-distribution.component';
import {ApUtilsModule}                         from '../ap-utils';
import {PDFExportModule}                       from '@progress/kendo-angular-pdf-export';
import {ApTooltipModule}                       from '../ap-tooltip/ap-tooltip.module';
import {ApResponsiveTextModule}                from '../ap-responsive-text/ap-responsive-text.module';
import {ApSectionHeaderModule}                 from '../ap-section-header/ap-section-header.module';
import {ApDynComponentModule}                  from '../ap-dyncomponent/ap-dyncomponent.module';
import {ApNutrientManagementOverviewComponent} from './components/ap-nutrient-management-overview.component';
import {ApNutrientPNeedComponent}              from './components/ap-nutrient-p-need.component';
import {ApNutrientManagementPlanningComponent} from './components/ap-nutrient-management-planning.component';
import {ApNutrientManagementBookingComponent}  from './components/ap-nutrient-management-booking.component';
import {ApPermissionModule}                    from '../ap-permission/ap-permission.module';
import {ApGetCropTypeNamePipe}                 from './pipes/ap-get-croptype-name.pipe';

@NgModule({
  declarations: [
    ApSoilSamplePlanningOverviewComponent,
    ApNutrientDistributionComponent,
    ApNutrientManagementOverviewComponent,
    ApNutrientPNeedComponent,
    ApNutrientManagementPlanningComponent,
    ApNutrientManagementBookingComponent,
    ApGetCropTypeNamePipe
  ],
  imports: [
    CommonModule,
    GridModule,
    ApCoreModule,
    ApIconModule,
    ApNutrientManagementRoutes,
    ApTranslationModule,
    ApUtilsModule,
    ButtonModule,
    PDFModule,
    PagerModule,
    BodyModule,
    HeaderModule,
    SharedModule,
    ExcelModule,
    PDFExportModule,
    ApTooltipModule,
    ApResponsiveTextModule,
    ApSectionHeaderModule,
    GroupModule,
    ApDynComponentModule,
    ApPermissionModule
  ],
  exports: [ApGetCropTypeNamePipe],
  providers: [ApGetCropTypeNamePipe]
})
export class ApNutrientManagementModule {
}
